/***
 * Copyright (c) Myia 2023-2025 - All Rights Reserved
 */

import { ChangeEventHandler } from 'react';

import { Input } from '@/components/ui/input';

const SearchBar = (props: { className?: string; onChange: ChangeEventHandler<HTMLInputElement> }) => {
    return (
        <div className={`h-10 relative ${props.className}`}>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                className="absolute w-6 h-6 text-gray-500 left-3 top-1/2 transform -translate-y-1/2"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
            >
                <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={1}
                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                />
            </svg>
            <Input type="text" placeholder="Search" className="pl-12 pr-4" onChange={props.onChange} />
        </div>
    );
};

export default SearchBar;
